import { types } from 'mobx-state-tree';
import { createStore } from '@/modules/widgets/lib';

const initState = {};

const Model = types
  .model('PerformanceModel', {
    fps: '-',
    bitrate: '-',
    lostRate: '-',
    cpu: '-',
    memory: '-',
  })
  .actions((self) => {
    const updateVideoInfo = (info) => {
      self.fps = `${info.fps.toFixed(0)}`;
      self.bitrate = `${info.bitrate.toFixed(0)}`;
      self.lostRate = `${info.lostRate.toFixed(0)}`;
    };
    const updateCpuMemory = (info) => {
      self.cpu = `${info.cpu}`;
      self.memory = `${info.memory}`;
    };
    return {
      updateVideoInfo,
      updateCpuMemory,
    };
  });

const performanceStore = createStore(Model, initState);

export default performanceStore;
